// Bookkeeping identifiers for the planner stores during onboarding. The
// session id is the store's twinBID key; these label the org/plan until the
// twin goes live.
export const ORG_BID = 'ONBOARDING';
export const ORG_NAME = 'Onboarding';
export const PLAN_NAME = 'Onboarding plan';
